export const BUCKET_DROPPABLE_CONTAINER_ID = "buckets";
